import { BaseService } from './base-service';

class OrgService extends BaseService {
  /********************************
   * 部门
   ********************************/
  /**
   *  获取当前部门列表
   *
   * @author ylq
   * @param  {Object} params
   * @param  {String} params.searchkey
   * @returns
   * @memberof OrgService
   */
  getDepartTreeList(params) {
    return this.request({
      method: 'get',
      url: `/sysDepartment/list`,
      params
    });
  }
  /**
   *  同步部门和用户数据
   *
   * @author ylq
   * @param  {Object} params
   * @param  {String} params.searchkey
   * @returns
   * @memberof OrgService
   */
  syncDepartUser(params) {
    return this.request({
      method: 'get',
      url: `/sysDepartment/sync`,
      params
    });
  }
  /**
   *  添加部门 编辑部门
   *
   * @author ylq
   * @param  {Object} data
   * @param  {String} data.ParentId
   * @param  {String} data.Name
   * @returns
   * @memberof OrgService
   */
  addDepart(data) {
    return this.request({
      method: 'post',
      url: `/client/admin/department`,
      data
    });
  }
  /**
   *  编辑部门
   *
   * @author ylq
   * @param  {Object} data
   * @param  {integer} data.DepId
   * @param  {String} data.Name
   * @returns
   * @memberof OrgService
   */
  editDepart(data) {
    return this.request({
      method: 'patch',
      url: `/client/admin/department`,
      data
    });
  }
  /**
   *  获取当前部门下用户列表
   *
   * @author ylq
   * @param  {Object} params
   * @param  {String} params.searchkey
   * @returns
   * @memberof OrgService
   */
  getUserList(params) {
    return this.request({
      method: 'post',
      url: `/user/pageV2`,
      data: params
    });
  }
  /**
   * @description: 组织用户-下载空模板/导出数据
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getDownload(params) {
    return this.request({
      method: 'post',
      url: `/user/download`,
      responseType: 'blob',
      data: params
    });
  }

  /**
   * @description: 部门/人员获取高级筛选字段
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getFilterFields(params) {
    return this.request({
      method: 'get',
      url: `/user/getFilterFields`,
      params
    });
  }
  /**
   * @description: 组织架构-搜索部门/人员
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  searchDepartUserList(params) {
    return this.request({
      method: 'get',
      url: `/user/getUserAndDeptByKeyWord`,
      params
    });
  }
  /**
   *  组织架构-获取部门下的人员
   *
   * @author ylq
   * @param  {Object} params
   * @param  {String} params.searchkey
   * @returns
   * @memberof OrgService
   */
  getDepartUserList(params) {
    return this.request({
      method: 'get',
      url: `/user/list`,
      params
    });
  }
  /********************************
   * 用户
   ********************************/
  /**
   *  转入离职用户数据
   *
   * @author ylq
   * @param  {Object} params
   * @param  {String} params
   * @returns
   * @memberof OrgService
   */
  transferUserData(params) {
    return this.request({
      method: 'post',
      url: `user/transfer`,
      data: params
    });
  }

  /**
   *  添加用户
   *
   * @author ylq
   * @param  {Object} data
   * @param  {String} data.Mobile  手机号
   * @param  {String} data.Name 名称
   * @param  {String} data.AvatarUrl 头像
   * @param  {String} data.JobTitle 职称
   * @param  {array[integer]} data.DepartmentIds 指定用户部门
   * @returns
   * @memberof OrgService
   */
  addUser(data) {
    return this.request({
      method: 'post',
      url: `/client/admin/user`,
      data
    });
  }
  /**
   *  编辑用户
   *
   * @author ylq
   * @param  {Object} data
   * @param  {String} data.UserId  用户id
   * @param  {String} data.Name 名称
   * @param  {String} data.AvatarUrl 头像
   * @param  {array[integer]} data.DepartmentIds 指定用户部门
   * @returns
   * @memberof OrgService
   */
  editUser(data) {
    return this.request({
      method: 'patch',
      url: `/client/admin/user/${data.UserId}`,
      data
    });
  }
  /**
   *  离职数据中心
   *
   * @author ldd
   * @param  {Object} data
   * @param  {integer} data.id  用户id
   * @returns
   * @memberof OrgService
   */
  // 统计所有离职数据量
  getTransferCount(data) {
    return this.request({
      method: 'post',
      url: `transfer/count`,
      data
    });
  }
  //离职人员列表
  getPersonList(params) {
    return this.request({
      method: 'get',
      url: `transfer/dimissionList`,
      params
    });
  }
  // 离职人员筛选接口
  getObjectListPageByDefault(data) {
    return this.request({
      method: 'post',
      url: `transfer/listPageSearchTurnover`,
      data
    });
  }
}

export const orgService = new OrgService();
